/**
 * Javascript file for the main function.
 * @author Adrian Rebmann, Yannik Sprengart, Steffen Schuhmann
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuex from "vuex";
import VueMaterial from "vue-material";
import Vuelidate from "vuelidate";
import VueVideoPlayer from "vue-video-player";
import "vue-material/dist/vue-material.min.css";
//import "vue-material/dist/theme/default.css";
import "video.js/dist/video-js.css";
import VueFuse from "vue-fuse";
import Vuetify from "vuetify";
import vueSmoothScroll from "vue2-smooth-scroll";
import VueParticles from "vue-particles";
import vuetify from "@/plugins/vuetify";

Vue.use(vueSmoothScroll);
Vue.use(VueParticles);
Vue.use(VueMaterial);
Vue.use(Vuelidate);
Vue.use(VueFuse);
Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(
  VueVideoPlayer /* {
  options: global default options,
  events: global videojs events
} */
);
Vue.use(vuetify);

/**
 * The router's configuration.
 */
router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/notFound");
  } else {
    next();
  }
});

Vue.config.productionTip = false;

/**
 * Create a new Vue instance and mount the app.
 */
/* eslint-disable no-new */
new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js